module.exports = __webpack_public_path__ + "img/teacher.2a74d11e.svg";